// removed by extract-text-webpack-plugin
module.exports = {"scroll":"_11fKWPvsYs9U9JZikvFV0q","sideMenu":"_53t0xAQ93DQ9DmbWUdRok","mask":"XJ5QDwKIbO8frMK8zqqI-","hamburger":"_2vE1RaNlOmWA3q1apUbAx8","logo":"DoEUZkWIhZh_JdTLGq97j","username":"_4SaeI1rUqNIHrQ6WE2JAu","section":"_3NS7VJxx6dDKpQGgbAs16g","expander":"_3PRGljUfp6Olpqzixu7P4D","links":"_154eYy0kZVmXsaiP1yKY3v","visible":"_2aoBFgevzmC7YbL-ymhJJ3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideMenu/SideMenu.scss
// module id = 1314
// module chunks = 1